// extracted by mini-css-extract-plugin
module.exports = {"container":"DestinationsByThematic_container__G7ZKO","tabList":"DestinationsByThematic_tabList__BGXOM"};